import { useState, useCallback } from "react";

// Backend may store these fields either as object {key: true} (admin save format)
// or as array ["key"] (agent panel save format). Normalize both into a flat
// {key: true} state used by the form checkboxes.
const parseCheckboxValues = (value) => {
  const result = {};
  if (!value) return result;
  if (Array.isArray(value)) {
    value.forEach((v) => {
      if (v) result[v] = true;
    });
  } else if (typeof value === "object") {
    Object.keys(value).forEach((key) => {
      if (value[key]) result[key] = true;
    });
  }
  return result;
};

const applyDiffToggle = (state, diffArray, marked) => {
  if (!Array.isArray(diffArray)) return;
  diffArray.forEach((value) => {
    state[value] = !state[value];
    marked[value] = true;
  });
};

export const usePropertyCheckboxState = () => {
  const [filtersSelect, setFiltersSelect] = useState({});
  const [supportFiltersSelect, setSupportFiltersSelect] = useState({});
  const [balconyFiltersSelect, setBalconyFiltersSelect] = useState({});
  const [checkboxesDifference, setCheckboxesDifference] = useState({});

  const handleCheckboxClick = useCallback((key, value) => {
    setFiltersSelect((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleSupportCheckboxClick = useCallback((key, value) => {
    setSupportFiltersSelect((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleBaclconyCheckboxClick = useCallback((key, value) => {
    setBalconyFiltersSelect((prev) => ({ ...prev, [key]: value }));
  }, []);

  const initializeCheckboxState = useCallback((property, diffMapped) => {
    const obj = parseCheckboxValues(property?.options?.property_additional_objects);
    const obj1 = parseCheckboxValues(property?.options?.property_additional_help);
    const obj2 = parseCheckboxValues(property?.options?.property_tech_appliance);
    const checkboxesMarked = {};

    if (diffMapped?.options) {
      applyDiffToggle(obj, diffMapped.options.property_additional_objects, checkboxesMarked);
      applyDiffToggle(obj1, diffMapped.options.property_additional_help, checkboxesMarked);
      applyDiffToggle(obj2, diffMapped.options.property_tech_appliance, checkboxesMarked);
    }

    setFiltersSelect(obj);
    setSupportFiltersSelect(obj1);
    setBalconyFiltersSelect(obj2);
    setCheckboxesDifference(checkboxesMarked);
  }, []);

  return {
    filtersSelect,
    supportFiltersSelect,
    balconyFiltersSelect,
    checkboxesDifference,
    handleCheckboxClick,
    handleSupportCheckboxClick,
    handleBaclconyCheckboxClick,
    initializeCheckboxState,
  };
};
